import { createContext } from "react";
import type { MapEngine } from "./core/MapEngine";

export const MapContext = createContext<MapEngine | null>(null);
